export default __webpack_public_path__ + "static/media/card5.11b46338.svg";